// src/services/validasi.ts
import api from './api';
import { LaporanMasalah, PaginatedResponse, ValidasiLog } from '../types';

export interface ValidasiPayload {
  action: 'approve' | 'reject' | 'revisi';
  catatan?: string;
}

export interface ValidasiFilter {
  status?: string;
  kategori?: number;
  unit?: number;
  risiko?: string;
  search?: string;
  page?: number;
  per_page?: number;
}

export const validasiService = {
  // Get laporan pending validasi level 1 (untuk Dekan/Kalem)
  getPendingLevel1: async (filters?: ValidasiFilter) => {
    const res = await api.get('/validasi/level1', { params: filters });
    return res.data as PaginatedResponse<LaporanMasalah>;
  },

  // Get laporan pending validasi level 2 (untuk Warek)
  getPendingLevel2: async (filters?: ValidasiFilter) => {
    const res = await api.get('/validasi/level2', { params: filters });
    return res.data as PaginatedResponse<LaporanMasalah>;
  },

  // Riwayat validasi level 1 (laporan yang sudah diproses Dekan/Kalem)
  getRiwayatLevel1: async (filters?: ValidasiFilter) => {
    const res = await api.get('/validasi/level1/riwayat', { params: filters });
    return res.data as PaginatedResponse<LaporanMasalah>;
  },

  // Riwayat validasi level 2 (laporan yang sudah diproses Warek)
  getRiwayatLevel2: async (filters?: ValidasiFilter) => {
    const res = await api.get('/validasi/level2/riwayat', { params: filters });
    return res.data as PaginatedResponse<LaporanMasalah>;
  },

  // Validasi level 1 (approve/reject)
  validateLevel1: async (laporanId: number, payload: ValidasiPayload) => {
    const res = await api.post(`/validasi/level1/${laporanId}`, payload);
    return res.data;
  },

  // Validasi level 2 (approve/reject)
  validateLevel2: async (laporanId: number, payload: ValidasiPayload) => {
    const res = await api.post(`/validasi/level2/${laporanId}`, payload);
    return res.data;
  },

  // Batch approve level 1
  batchApproveLevel1: async (laporanIds: number[], catatan?: string) => {
    const res = await api.post('/validasi/level1/batch-approve', {
      ids: laporanIds,
      catatan,
    });
    return res.data;
  },

  // Batch approve level 2
  batchApproveLevel2: async (laporanIds: number[], catatan?: string) => {
    const res = await api.post('/validasi/level2/batch-approve', {
      ids: laporanIds,
      catatan,
    });
    return res.data;
  },

  // Get validasi history for a laporan
  getHistory: async (laporanId: number) => {
    const res = await api.get(`/validasi/history/${laporanId}`);
    return res.data as ValidasiLog[];
  },

  // Get detail validation info for a laporan
  getDetail: async (laporanId: number) => {
    const res = await api.get(`/validasi/detail/${laporanId}`);
    return res.data as {
      laporan: LaporanMasalah;
      validations: any[];
      timeline: any[];
    };
  },

  // Get statistics
  getStats: async () => {
    const res = await api.get('/validasi/stats');
    return res.data as {
      pending_level1: number;
      pending_level2: number;
      approved_today_l1: number;
      rejected_today_l1: number;
      approved_today_l2: number;
      rejected_today_l2: number;
    };
  },
};